import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const slTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Ime (male črke, brez posebnih znakov)',
    add: 'Dodaj',
    allowedFileTypes: 'Dovoljene vrste datotek',
    allowedFileTypesDescription:
      'Omejite dovoljene vrste datotek (npr. slika/*, aplikacija/pdf). Pustite prazno, da omogočite vse vrste.',
    allowMultipleFiles: 'Dovoli več datotek',
    amountInCents: 'Znesek v centih',
    basePrice: 'Osnovna cena',
    bcc: 'BCC',
    brand: 'Znamka',
    cc: 'CC',
    checkboxPlural: 'Potrditveno polje Polja',
    checkboxSingular: 'Potrditveno polje',
    checkedByDefault: 'Privzeto označeno',
    chooseConfirmationType:
      'Izberite, ali želite prikazati sporočilo na strani ali preusmeriti na drugo stran, ko oddajo obrazec.',
    condition: 'Pogoj',
    confirmationMessage: 'Potrditveno sporočilo',
    confirmationType: 'Vrsta potrditve',
    countryPlural: 'Country Fields',
    countrySingular: 'Država',
    creditCard: 'Kreditna kartica',
    customURL: 'URL po meri',
    datePlural: 'Datumska polja',
    dateSingular: 'Datum',
    defaultValue: 'Privzeta vrednost',
    divide: 'Razdeli',
    documentToLinkTo: 'Dokument za povezavo',
    doesNotEqual: 'Ni enako',
    emailFrom: 'E-pošta od',
    emailPlural: 'E-poštna polja',
    emailsDescription:
      'Pošljite e-pošto po meri, ko je obrazec oddan. Uporabite sezname, ločene z vejicami, da pošljete isto e-pošto več prejemnikom. Če se želite sklicevati na vrednost iz tega obrazca, ovijte ime tega polja z dvojnimi zavitimi oklepaji, tj. {{firstName}}. Uporabite lahko nadomestni znak {{*}} za izpis vseh podatkov in {{*:table}} za oblikovanje tabele HTML v e-pošti.',
    emailSingular: 'E-pošta',
    emailTo: 'Email To',
    equals: 'Enako',
    field: 'Polje',
    fields: 'Polja',
    fieldWidth: 'Širina polja (v odstotkih)',
    hasAnyValue: 'Ima kakršno koli vrednost',
    internalLink: 'Notranja povezava',
    label: 'Oznaka',
    maxFileSize: 'Največja velikost datoteke (bajti)',
    maxFileSizeDescription: 'Največja velikost datoteke v bajtih. Pustite prazno, če ni omejitve.',
    message: 'Sporočilo',
    messageDescription: 'Vnesite sporočilo, ki naj bo poslano v tem e-poštnem sporočilu.',
    messagePlural: 'Bloki sporočil',
    messageSingular: 'Sporočilo',
    mimeType: 'Vrsta MIME',
    mimeTypePlural: 'Vrste MIME',
    mimeTypeSingular: 'Vrsta MIME',
    multiply: 'Pomnožite',
    numberPlural: 'Številska polja',
    numberSingular: 'številka',
    optionPlural: 'Možnosti',
    optionSingular: 'Možnost',
    paymentFieldPlural: 'Polja za plačilo',
    paymentFieldSingular: 'Plačilo',
    paymentProcessor: 'Procesor plačil',
    paymentStatus: 'Stanje',
    placeholder: 'Placeholder',
    priceConditions: 'Cenovni pogoji',
    priceConditionsPlural: 'Cenovni pogoji',
    priceConditionsSingular: 'Cenovni pogoj',
    radioOptions: 'Možnosti radijskih atributov',
    radioPlural: 'Radio Fields',
    radioSingular: 'Radio',
    redirect: 'Preusmeri',
    replyTo: 'Odgovori na',
    required: 'Obvezno',
    selectOptions: 'Izberite Možnosti',
    selectPlural: 'Izberite Polja',
    selectSingular: 'Izberite',
    statePlural: 'Državna polja',
    stateSingular: 'Država',
    staticValue: 'Statična vrednost',
    subject: 'Predmet',
    submitButton: 'Oznaka gumba za pošiljanje',
    subtract: 'Odštej',
    textareaPlural: 'Polja Textarea',
    textareaSingular: 'Textarea',
    textPlural: 'Besedilna polja',
    textSingular: 'Besedilo',
    title: 'Naslov',
    token: 'žeton',
    uploadCollection: 'Naloži zbirko',
    uploadCollectionDescription: 'Izberite, v katero zbirko za nalaganje želite shraniti datoteke',
    uploadFieldPlural: 'Polja za nalaganje',
    uploadFieldSingular: 'Naloži',
    urlToRedirectTo: 'URL za preusmeritev',
    value: 'Vrednost',
    valueOfField: 'Vrednost polja',
    valueType: 'Vrsta vrednosti',
  },
}

export const sl: PluginLanguage = {
  dateFNSKey: 'sl-SI',
  translations: slTranslations,
}
